import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { HOST } from "Constant/Constant";

export const staffUserApi = createApi({
  reducerPath: "staffUserApi",
  baseQuery: fetchBaseQuery({
    baseUrl: HOST,
  }),
  tagTypes: ["StaffUser"],
  endpoints: (builder) => ({
    getStaffUsersList: builder.query({
      query: ({ page, limit, search, role, isActive, siteid, sortBy, sortOrder } = {}) => {
        const params = new URLSearchParams();
        if (page) params.append("page", page);
        if (limit) params.append("limit", limit);
        if (search?.trim()) params.append("search", search?.trim());
        if (role) {
          if (Array.isArray(role)) {
            role.forEach((r) => params.append("role", r));
          } else {
            params.append("role", role);
          }
        }
        if (isActive !== undefined && isActive !== "") params.append("isActive", isActive);
        if (siteid) params.append("siteid", siteid);
        if (sortBy) params.append("sortBy", sortBy);
        if (sortOrder) params.append("sortOrder", sortOrder);
        return {
          url: `/staff/get-user?${params.toString()}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
      providesTags: ["StaffUser"],
    }),

    addStaffUser: builder.mutation({
      query: ({ body }) => ({
        url: "/staff/add-user",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["StaffUser"],
    }),

    updateStaffUser: builder.mutation({
      query: ({ body }) => ({
        url: "/staff/update-user",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["StaffUser"],
    }),

    getStaffStores: builder.query({
      query: ({ staffRole } = {}) => {
        const params = new URLSearchParams({ all: "true" });
        if (staffRole) params.append("staffRole", staffRole);
        return {
          url: `/staff/stores?${params.toString()}`,
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
      },
    }),

    deleteStaffUser: builder.mutation({
      query: (body) => ({
        url: "/staff/delete-user",
        method: "POST",
        body,
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      }),
      invalidatesTags: ["StaffUser"],
    }),
  }),
});

export const {
  useGetStaffUsersListQuery,
  useGetStaffStoresQuery,
  useAddStaffUserMutation,
  useUpdateStaffUserMutation,
  useDeleteStaffUserMutation,
} = staffUserApi;
